// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import { store } from "./vuex/index";
import "@/common/reset.css"; /*引入公共样式*/
Vue.config.productionTip = false;
import * as filter from "./filter";
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key]);
});
router.beforeEach((to, from, next) => {
  store.dispatch("closeMenu");
  store.dispatch("firstTitle", to.meta.firstTitle);
  store.dispatch("secondTitle", to.meta.secondTitle);
  if (store.state.firstTitle) {
    window.document.title = store.state.firstTitle;
  } else {
    window.document.title = "国家海洋标准计量中心";
  }
  next();
});
router.afterEach((to, from) => {
  setTimeout(() => {
    document.getElementById("main-content").scrollTop = 0;
  }, 0);
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js